"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSmartDocFieldValue = exports.getSmartDocFieldEmptyValue = void 0;
const getSmartDocFieldEmptyValue = () => {
    const emptyDoc = {
        type: "doc",
        content: [],
    };
    return { data: emptyDoc, html: "", preview: "" };
};
exports.getSmartDocFieldEmptyValue = getSmartDocFieldEmptyValue;
const generateSmartDocFieldValue = (value) => {
    return { ...(0, exports.getSmartDocFieldEmptyValue)(), ...value };
};
exports.generateSmartDocFieldValue = generateSmartDocFieldValue;
